import { UserInfo } from '../../user/userInfo.js';
import { UserWallet } from '../../user/wallet.js';
import { getCheapestVariant } from '../utilities.js';

export async function getSliderItemDescription(item) {
  const { getTranslation } = await import('../../tools/translations.js');

  let fromTranslation = await getTranslation('from'),
    multipleVariantsTranslation = item.variants.length > 1 ? (await getTranslation('multiple_variants')) + ', ' : '',
    tCApplyTranslation = await getTranslation('t_c_apply');

  return `${item.variants.length > 1 ? fromTranslation : ''} ${
    item.variants.length > 0 ? getShortenVariant(getCheapestVariant(item.variants)) : ''
  } EP <span>${multipleVariantsTranslation}${tCApplyTranslation}</span>`;
}

export function createSliderItemOptions(item) {
  if (item.variants.length === 0) {
    return '';
  }

  if (item.estimator === 'true') {
    return `<div class="panel-thumb-options progressbar d-none">
            <div class="energyShop-product-estimator-progressBar">
              <span class="energyShop-product-estimator-value">-</span>
					    <div class="energyShop-product-estimator-bar" style="width: 0%;"></div>
				    </div>
          </div>`;
  }

  if (item.variants.length === 1) {
    return '';
  }

  return `<div class="panel-thumb-options amount">
  ${createSliderItemVariants(item)}
    </div>`;
}

export async function addListenerSliderItemOptionEstimator(itemEl, item) {
  const userInfoInstance = new UserInfo();
  const isLogged = await userInfoInstance.isLoggedAsync();
  if (!isLogged) {
    return;
  }

  const container = itemEl.querySelector('.panel-thumb-options');
  const cheapestVariant = parseInt(getCheapestVariant(item.variants).price);

  const userWallet = new UserWallet();
  userWallet.addObserver((walletData) => {
    container.classList.remove('d-none');

    container.querySelector('.energyShop-product-estimator-value').innerHTML =
      Math.round((walletData.points / cheapestVariant) * 100 * 100) / 100 + '%';

    container.querySelector('.energyShop-product-estimator-bar').style.width =
      (walletData.points / cheapestVariant) * 100 + '%';
  });
}

export function createSliderItemVariants(item) {
  const valuesSet = new Set();
  for (const itemVariant of item.variants) {
    let value;
    if (item.kind === 'no_deposit') {
      value = itemVariant.value;
    } else if (item.kind === 'reload') {
      value = `${itemVariant.amount}%`;
    } else {
      value = itemVariant.amount;
    }
    valuesSet.add(value);
  }

  const variantsAmount = Array.from(valuesSet)
    .map((value) => `<span>${value}</span>`)
    .join('');

  return variantsAmount;
}

function getShortenVariant(variant) {
  const number = variant.price;
  if (number >= 1000000) {
    return (number / 1000000).toFixed(3).replace(/\.?0+$/, '') + 'M';
  } else if (number >= 1000) {
    return number.toLocaleString('en-US');
  } else {
    return number.toString();
  }
}

// Restrictions
export function checkItemRestrictions(item, userProfile) {
  if (!checkItemCountryRestriction(item)) {
    return false;
  }

  const profileCompability = checkProfileCompability(item, userProfile);
  return checkUserCountryRestriction(item, profileCompability);
}

function checkProfileCompability(item, userProfile) {
  if (
    item.user_restriction_type != 'Unrestricted' &&
    item.user_restriction_type != '' &&
    item.user_restriction_config != ''
  ) {
    const itemProfileList = item.user_restriction_config.split(',');
    for (const itemProfile of itemProfileList) {
      if (userProfile.includes(itemProfile) || itemProfile == userProfile) {
        return true;
      }
    }
  }

  return false;
}

function checkItemCountryRestriction(item) {
  return (
    item.country_restriction_type == 'Global' ||
    (item.country_restriction_type == 'Allowance mode' &&
      (item.country_restriction_config == '' || item.country_restriction_config.indexOf(_CMS_USERIP) >= 0)) ||
    (item.country_restriction_type == 'Restriction mode' && item.country_restriction_config.indexOf(_CMS_USERIP) == -1)
  );
}

function checkUserCountryRestriction(item, profileCompability) {
  return (
    item.user_restriction_type == 'Unrestricted' ||
    item.user_restriction_type == '' ||
    (item.user_restriction_type == 'User allowance mode' && profileCompability) ||
    (item.user_restriction_type == 'User restriction mode' && !profileCompability)
  );
}
